export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-05.1f38d379.jpg";